import React, { useState, useEffect, useRef, useCallback } from "react";
import Grid from "@mui/material/Grid2";

import { 
  Campaign,
  QuestBoard,
} from "@dndModels";

import AddButton from "@components/input/buttons/icon_buttons/AddButton";
import DandDAPI from "@dndUtilities/system_api";
import LoadingBox from "@components/input/LoadingBox";
import CommonUtilities from "@utilities/common_utilities";
import FlexBox from "@components/layout/FlexBox";
import QuestBoardInput from "./QuestBoardInput";
import RefreshButton from "@components/input/buttons/icon_buttons/RefreshButton";

interface Props {
  campaign: Campaign;
}

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CampaignQuestBoardsInput({
  campaign,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const load = useCallback( async () => {
    // debugger;
    if (campaign.quest_boards.length === 0) {
      campaign.quest_boards = await api.getCampaignObjects<QuestBoard>({ data_type: "campaign_quest_board", campaign });
    }
    setLoading(false);
  }, [campaign]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched, load]);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderQuestBoards = () => {
    return (
      <FlexBox>
        <Grid container spacing={0} direction="row">
          { campaign.quest_boards.map(quest_board => {
            return (
              <Grid size={{ xs:12, sm: 6, md: 4, lg: 3 }} key={quest_board._id}>
                <QuestBoardInput
                  campaign={campaign}
                  quest_board={quest_board} 
                  onDelete={ async () => {
                    setProcessing(true);
                    await api.deleteObject("campaign_quest_board", quest_board);
                    campaign.quest_boards = campaign.quest_boards.filter(o => o._id !== quest_board._id);
                    setProcessing(false);
                  }} 
                />
              </Grid>
            );
          })}
        </Grid>
      </FlexBox>
    )
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  }
  return (
    <FlexBox direction="column" style={{ width: "100%" }}>
      { api.user && api.user._id === campaign.owner_id &&
        <FlexBox direction="row">
          <FlexBox xs_expand={0} className="padded">
            <AddButton
              disabled={processing}
              onClick={ async () => {
                const new_quest_board = new QuestBoard();
                new_quest_board.campaign_id = campaign._id;
                setProcessing(true);
                await api.upsertObject("campaign_quest_board", new_quest_board);
                campaign.quest_boards.push(new_quest_board);
                setProcessing(false);
              }}
            />
          </FlexBox>
          <FlexBox xs_expand={0} className="padded">
            <RefreshButton
              disabled={processing}
              onClick={ async () => {
                campaign.quest_boards = [];
                setProcessing(true);
                campaign.quest_boards = await api.getCampaignObjects<QuestBoard>({ data_type: "campaign_quest_board", campaign });
                setProcessing(false);
              }}
            />
          </FlexBox>
        </FlexBox>
      }
      { renderQuestBoards() }
    </FlexBox>
  );
}
